import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { NavigationActions } from '@react-navigation/core';
import invariant from '../utils/invariant';
/**
 * Component that renders the sidebar screen of the drawer.
 */

var DrawerSidebar =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DrawerSidebar, _React$PureComponent);

  function DrawerSidebar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DrawerSidebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DrawerSidebar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_getScreenOptions", function (routeKey) {
      var descriptor = _this.props.descriptors[routeKey];
      invariant(descriptor.options, 'Cannot access screen descriptor options from drawer sidebar');
      return descriptor.options;
    });

    _defineProperty(_assertThisInitialized(_this), "_getLabel", function (_ref) {
      var focused = _ref.focused,
          tintColor = _ref.tintColor,
          route = _ref.route;

      var _this$_getScreenOptio = _this._getScreenOptions(route.key),
          drawerLabel = _this$_getScreenOptio.drawerLabel,
          title = _this$_getScreenOptio.title;

      if (drawerLabel) {
        return typeof drawerLabel === 'function' ? drawerLabel({
          tintColor: tintColor,
          focused: focused
        }) : drawerLabel;
      }

      if (typeof title === 'string') {
        return title;
      }

      return route.routeName;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderIcon", function (_ref2) {
      var focused = _ref2.focused,
          tintColor = _ref2.tintColor,
          route = _ref2.route;

      var _this$_getScreenOptio2 = _this._getScreenOptions(route.key),
          drawerIcon = _this$_getScreenOptio2.drawerIcon;

      if (drawerIcon) {
        return typeof drawerIcon === 'function' ? drawerIcon({
          tintColor: tintColor,
          focused: focused
        }) : drawerIcon;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "_onItemPress", function (_ref3) {
      var route = _ref3.route,
          focused = _ref3.focused;

      if (focused) {
        _this.props.navigation.closeDrawer();
      } else {
        _this.props.navigation.dispatch(NavigationActions.navigate({
          routeName: route.routeName
        }));
      }
    });

    return _this;
  }

  _createClass(DrawerSidebar, [{
    key: "render",
    value: function render() {
      var ContentComponent = this.props.contentComponent;

      if (!ContentComponent) {
        return null;
      }

      var state = this.props.navigation.state;
      invariant(typeof state.index === 'number', 'should be set');
      return React.createElement(View, {
        style: [styles.container, this.props.style]
      }, React.createElement(ContentComponent, _extends({}, this.props.contentOptions, {
        navigation: this.props.navigation,
        descriptors: this.props.descriptors,
        drawerOpenProgress: this.props.drawerOpenProgress,
        items: state.routes,
        activeItemKey: state.routes[state.index] ? state.routes[state.index].key : null,
        screenProps: this.props.screenProps,
        getLabel: this._getLabel,
        renderIcon: this._renderIcon,
        onItemPress: this._onItemPress,
        drawerPosition: this.props.drawerPosition
      })));
    }
  }]);

  return DrawerSidebar;
}(React.PureComponent);

export default DrawerSidebar;
var styles = StyleSheet.create({
  container: {
    flex: 1
  }
});